import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../supabase';

// Fixed admin credentials
const ADMIN_EMAIL = 'admin@example.com';
const ADMIN_PASSWORD = 'adminPassword123!';

function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // First check if credentials match our fixed admin credentials
    if (email === ADMIN_EMAIL && password === ADMIN_PASSWORD) {
      try {
        // Try to sign in with Supabase
        const { data, error } = await supabase.auth.signInWithPassword({
          email: email,
          password: password
        });

        if (error) {
          // If Supabase doesn't have the user, we'll still allow login with our fixed credentials
          console.log('Supabase auth failed, but using fixed credentials: ', error.message);
          // Set some authentication state in localStorage as a fallback
          localStorage.setItem('isAdminAuthenticated', 'true');
          navigate('/admin/dashboard');
        } else {
          // Successful login with Supabase
          localStorage.setItem('isAdminAuthenticated', 'true');
          navigate('/admin/dashboard');
        }
      } catch (err) {
        console.error('Login error:', err);
        // Still navigate if fixed credentials match, even if Supabase has an issue
        localStorage.setItem('isAdminAuthenticated', 'true');
        navigate('/admin/dashboard');
      }
    } else {
      setError('Invalid credentials');
    }
    
    setLoading(false);
  };

  return (
    <div className="admin-login-container">
      <div className="login-form-wrapper">
        <h2>Admin Login</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        <div style={{ marginTop: '20px', textAlign: 'center', color: '#666', fontSize: '14px' }}>
          <p>Admin Credentials:</p>
          <p>Email: admin@example.com</p>
          <p>Password: adminPassword123!</p>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin; 